import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Table, TableHead, TableRow, TableCell, TableBody, Chip } from '@mui/material'
import { useQuery } from '@tanstack/react-query'
import { getBomHistory, type BomStatus } from '../../api/productie'

const STATUS_LABEL: Record<BomStatus, string> = {
  Draft: 'Ciornă', PendingApproval: 'În aprobare', Activa: 'Activă', Arhivata: 'Arhivată', Respinsa: 'Respinsă',
}

export default function BomHistoryDialog({ id, onClose }: { id: string | null; onClose: () => void }) {
  const open = id !== null
  const { data } = useQuery({ queryKey: ['productie', 'retetar', id, 'istoric'], queryFn: () => getBomHistory(id!), enabled: open })

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Istoric versiuni</DialogTitle>
      <DialogContent>
        <Table size="small">
          <TableHead>
            <TableRow><TableCell>Versiune</TableCell><TableCell>Status</TableCell><TableCell>Valabil</TableCell><TableCell>Motiv</TableCell></TableRow>
          </TableHead>
          <TableBody>
            {data?.map((h) => (
              <TableRow key={h.id}>
                <TableCell>v{h.version}</TableCell>
                <TableCell><Chip size="small" label={STATUS_LABEL[h.status]} /></TableCell>
                <TableCell>{h.validFrom}{h.validTo ? ` – ${h.validTo}` : ''}</TableCell>
                <TableCell>{h.changeReason ?? '—'}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2.5 }}>
        <Button onClick={onClose}>Închide</Button>
      </DialogActions>
    </Dialog>
  )
}
